export default __webpack_public_path__ + "static/media/linkedin-circled-scale.9ecc0903.gif";